import { Pipe } from '@angular/core';
import { isArray } from '../utils/utils';
var MinPipe = (function () {
    function MinPipe() {
    }
    MinPipe.prototype.transform = function (input) {
        if (!isArray(input)) {
            return input;
        }
        if (input.length === 0) {
            return undefined;
        }
        var min = input[0];
        input.forEach(function (value) {
            if (min > value) {
                min = value;
            }
        });
        return min;
    };
    return MinPipe;
}());
export { MinPipe };
MinPipe.decorators = [
    { type: Pipe, args: [{
                name: 'min'
            },] },
];
/** @nocollapse */
MinPipe.ctorParameters = function () { return []; };
//# sourceMappingURL=min.pipe.js.map


//////////////////
// WEBPACK FOOTER
// ./~/angular-pipes/esm/aggregate/min.pipe.js
// module id = 225
// module chunks = 103